export * from './baCard.component';



// WEBPACK FOOTER //
// /app/src/app/theme/components/baCard/index.ts